var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeeds(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "936F493E-0238-430A-B10D-728604647C16-17830-0009432B630F3691") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Inventory",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Inventory-view-(w-Images)",
    transform: "translate(-9.000000, -170.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu-/-sidenav-/-expanded"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Leads",
    transform: "translate(0.000000, 154.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Help",
    transform: "translate(9.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5,8 C8.776,8 9,8.224 9,8.5 C9,8.776 8.776,9 8.5,9 C8.224,9 8,8.776 8,8.5 C8,8.224 8.224,8 8.5,8 Z M5.40025,5.4 C5.15991667,6.099 4.51125,6.6 3.75,6.6 C2.784,6.6 2,5.7936 2,4.8 C2,3.8064 2.784,3 3.75,3 C4.51125,3 5.15991667,3.501 5.40025,4.2 L13.375,4.2 C14.824,4.2 16,5.4096 16,6.9 C16,8.3904 14.824,9.6 13.375,9.6 L10.65025,9.6 C10.4099167,10.299 9.76125,10.8 9,10.8 C8.23875,10.8 7.59008333,10.299 7.34975,9.6 L4.625,9.6 C3.82,9.6 3.16666667,10.272 3.16666667,11.1 C3.16666667,11.928 3.82,12.6 4.625,12.6 L12.59975,12.6 C12.8400833,11.901 13.48875,11.4 14.25,11.4 C15.216,11.4 16,12.2064 16,13.2 C16,14.1936 15.216,15 14.25,15 C13.48875,15 12.8400833,14.499 12.59975,13.8 L4.625,13.8 C3.176,13.8 2,12.5904 2,11.1 C2,9.6096 3.176,8.4 4.625,8.4 L7.34975,8.4 C7.59008333,7.701 8.23875,7.2 9,7.2 C9.76125,7.2 10.4099167,7.701 10.65025,8.4 L13.375,8.4 C14.18,8.4 14.8333333,7.728 14.8333333,6.9 C14.8333333,6.072 14.18,5.4 13.375,5.4 L5.40025,5.4 Z",
    id: "Fill-1"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeeds);
export default __webpack_public_path__ + "static/media/Feeds.c596bdf3fef4651412beb2c130a4e1f6.svg";
export { ForwardRef as ReactComponent };